import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { InventoryItemEdition } from '../inventory-item/item-types/app';

export interface Edition extends InventoryItemEdition {
  isActive?: boolean;
}

@Component({
  selector: 'inventory-ui-edition-selector',
  templateUrl: './edition-selector.component.html',
  styleUrls: ['./edition-selector.component.scss'],
})
export class EditionSelectorComponent {
  @Input() selectedEditionId!: string;
  @Input() editions!: Edition[];

  @Output() editionSelectionChange = new EventEmitter<string>();

  handleEditionChange(event: MatSelectChange): void {
    this.editionSelectionChange.emit(event.value);
  }
}
